import { t } from '@lingui/core/macro';

/** Erro do Cognito com `code`, como chega nos callbacks. */
export interface CognitoErrorLike {
  code?: string;
  name?: string;
  message?: string;
}

/**
 * Normaliza o código como o `onFailure` do legado: "User is disabled." e "session is expired" chegam
 * sem código próprio e ganham um sintético.
 */
export function cognitoErrorCode(error: unknown): string | undefined {
  const e = (typeof error === 'object' && error !== null ? error : {}) as CognitoErrorLike;
  const message = e.message ?? '';
  // Texto que o Cognito devolve (casado, não exibido).
  /* eslint-disable lingui/no-unlocalized-strings */
  if (message === 'User is disabled.') return 'UserIsDisabledException';
  if (message.includes('session is expired')) return 'SessionExpiredException';
  /* eslint-enable lingui/no-unlocalized-strings */
  return e.code ?? e.name;
}

/** Tabela `codeToMessage` do legado (services/identity), texto literal em pt-BR. */
export function codeToMessage(code: string | undefined): string {
  if (!code || code === 'null' || code === 'undefined') return t`Erro inesperado. Tente novamente.`;
  switch (code) {
    case 'LimitExceededException':
      return t`Limite de tentativas excedido. Tente novamente mais tarde.`;
    case 'UserNotConfirmedException':
      return t`Este usuário não esta confirmado ainda. Confirme antes de prosseguir.`;
    case 'PasswordResetRequiredException':
      return t`Você precisa alterar sua senha. Clique em 'Esqueci minha senha'`;
    case 'NotAuthorizedException':
      return t`Usuário e senha incorretos.`;
    case 'ResourceNotFoundException':
      return t`Usuário e/ou senha incorretos.`;
    case 'UsernameExistsException':
      return t`Este e-mail/nome de usuário já esta sendo utilizado.`;
    case 'UserNotFoundException':
      return t`Este usuário não existe.`;
    case 'CodeMismatchException':
      return t`Código inválido. Tente novamente.`;
    case 'EnableSoftwareTokenMFAException':
      return t`Não foi possível validar o código. Tente novamente.`;
    case 'ExpiredCodeException':
      return t`O código informado expirou. Tente novamente com um novo código`;
    case 'UserIsDisabledException':
      return t`Usuário desativado. Entre em contato com o administrador do sistema.`;
    case 'SessionExpiredException':
      return t`Sua sessão expirou por inatividade. Inicie o processo novamente.`;
    default:
      return t`Ocorreu um erro ao realizar a requisição. Tente novamente.`;
  }
}

export const messageForError = (error: unknown) => codeToMessage(cognitoErrorCode(error));
